import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import IdentityService from '@/service/identity';
import { environment } from '@/environments/environment';

Vue.use(Router)

const identity = new IdentityService();
const router = new Router({
  mode: 'history',
  routes
})
/**
 * 配置路由验证
 * 
 */
router.beforeEach(
  (to, from, next) => {
    if (to.path == "/wezhanconfig") {
      window.location.href = `${environment.wezhanconfigUrl}/jump`;
      return;
    }
    if (to.matched.some(record => record.meta.title)) {
      document.title = to.meta.title;
    }
    if (to.matched.some(record => record.meta.requiresAuth) && !identity.isAuthenticated(to)) {
      next({
        path: '/login.html',
        query: { redirect: to.fullPath }
      });
      return;
    }
    if (to.matched.some(record => record.meta.requiresRole) && !identity.checkRole(to.meta.requiresRole)) {
      next({
        path: '/norole.html',
        query: { redirect: to.fullPath }
      });
      return;
    }
    next();
  });
export default router



// WEBPACK FOOTER //
// ./src/router/index.js